import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import CatalogPageShell from "../Products/CatalogPageShell.jsx";
import TabNavigation from "../TabNavigation.jsx";
import AirtableRecord from "./AirtableRecord";
import EbayUploadLanding from "./eBay Upload/EbayUploadLanding";
import ShopifyUploadLanding from "./Shopify Upload/ShopifyUploadLanding";
import "./uploadProducts.css";

const TABS = [
    { label: "Upload to Walmart", value: 0 },
    { label: "Upload to eBay", value: 1 },
    { label: "Upload to Shopify", value: 2 },
];

export default function InventoryUploadLanding() {
    const [searchParams, setSearchParams] = useSearchParams();
    const [tab, setTab] = useState(() => {
        const fromUrl = parseInt(searchParams.get("page"), 10);
        return TABS.some((item) => item.value === fromUrl - 1) ? fromUrl - 1 : 0;
    });

    const changeTab = (_event, next) => {
        setTab(next);
        setSearchParams({ page: String(next + 1) });
    };

    useEffect(() => {
        const raw = searchParams.get("page");
        const fromUrl = parseInt(raw, 10);
        const valid = TABS.some((item) => item.value === fromUrl - 1);
        if (valid) {
            if (fromUrl - 1 !== tab) setTab(fromUrl - 1);
            return;
        }
        if (tab !== 0) setTab(0);
        if (raw !== "1") {
            setSearchParams({ page: "1" }, { replace: true });
        }
    }, [searchParams, setSearchParams, tab]);

    return (
        <CatalogPageShell
            title="Upload Products"
            subtitle="Search by SKU to upload inventory to Walmart, eBay, or Shopify."
        >
            <div className="upload-stack">
                <div style={{ flexShrink: 0 }}>
                    <TabNavigation value={tab} onChange={changeTab} tabs={TABS} />
                </div>
                <div className="upload-stack-body">
                    {tab === 1 ? (
                        <EbayUploadLanding />
                    ) : tab === 2 ? (
                        <ShopifyUploadLanding />
                    ) : (
                        <AirtableRecord channel="walmart" />
                    )}
                </div>
            </div>
        </CatalogPageShell>
    );
}
